<template>
  <v-app light>

    <v-toolbar dense style="position: fixed">
      </v-toolbar-items>
      <v-btn v-bind:disabled="!validlogin" v-bind:class="{grey : materieelSelected}" v-on:click.native="materieelClicked" >Materieel</v-btn>
      <v-btn v-bind:disabled="!validlogin" v-bind:class="{grey : wervenSelected}" v-on:click.native="wervenClicked" >Werven</v-btn>
      <!--<v-btn v-bind:disabled="!validlogin" v-bind:class="{grey : handleidingenSelected}" v-on:click.native="handleidingenClicked" >Handleidingen</v-btn>-->
      <v-spacer></v-spacer>
      <v-btn v-bind:class="{grey : accountSelected}" v-on:click.native="accountClicked" >Account</v-btn>
    </v-toolbar>

<div style="overflow: auto; padding-top: 48px;">
    <div v-show="materieelSelected"><materieel></materieel></div>
    <div v-show="wervenSelected"><werven></werven></div>
    <div v-show="handleidingenSelected"><handleidingen></handleidingen></div>
    <div v-show="accountSelected">

      <div v-if="validlogin" class="text-xs-center elevation-12" style="width: 60%; min-width: 400px; margin-left: auto; margin-right: auto;margin-top: 20px; margin-bottom: 20px; padding: 10px;">
        <div class="text-lg-center" style="font-size: 18px;">WELKOM, {{user.username}}</div>
        <br>
        <br>
        <v-btn primary v-on:click.native="uitloggenClicked" class="text-xs-center">AFMELDEN</v-btn>
        <div v-if="user_admin">
          <br>
          <div class="text-lg-left" style="font-size: 18px;">GEBRUIKERS:</div>
          <br>

<div>
  <v-layout row wrap>
       <v-flex xs6>
         <grid
           :data="UsersData"
           :columns="UsersColumns"
           @GridRowClicked="GridRowClicked"
           >
         </grid>
       </v-flex>
       <v-flex xs6 v-show="UserGeselecteerd">
         <v-text-field
             v-model="UserUsername"
             label="Gebruikersnaam"
           ></v-text-field>
           <v-text-field
               v-model="UserVoornaam"
               label="Voornaam"
             ></v-text-field>
             <v-text-field
                 v-model="UserNaam"
                 label="Naam"
               ></v-text-field>
              <v-layout row wrap>
               <v-flex xs6><v-btn class="green" v-on:click.native="UserOpslaanClicked" >Opslaan</v-btn></v-flex>
               <v-flex xs6><v-btn class="red" v-on:click.native="UserVerwijderenClicked" >Verwijderen</v-btn></v-flex>
   </v-layout>
   <v-text-field
       v-model="UserWW"
       label="Nieuw Wachtwoord"
       :append-icon="e2 ? 'visibility' : 'visibility_off'"
       @click:append="() => (e2 = !e2)"
       :type="e2 ? 'password' : 'text'"
       v-on:keyup.native="kp"
     ></v-text-field>
   <v-layout row wrap>
    <v-flex xs6><v-btn class="green" v-on:click.native="UserWWWijzigen" >Wachtwoord Wijzigen</v-btn></v-flex>
    <v-flex xs6></v-flex>
</v-layout>
       </v-flex>

     </v-layout>
</div>





        </div>
      </div>


      <div v-if="!validlogin" class="text-xs-center elevation-12" style="width: 60%; min-width: 400px; margin-left: auto; margin-right: auto;margin-top: 20px; margin-bottom: 20px; padding: 10px;">

          <v-text-field
              v-model="gebruikersnaam"
              label="Gebruikersnaam"
            ></v-text-field>
            <v-text-field
                v-model="wachtwoord"
                label="Wachtwoord"
                :append-icon="e1 ? 'visibility' : 'visibility_off'"
                @click:append="() => (e1 = !e1)"
                :type="e1 ? 'password' : 'text'"
                v-on:keyup.native="kp"
              ></v-text-field>
              <div style="color: red;" v-show="showError">{{errormsg}}</div>
          <v-btn primary v-on:click.native="inloggenClicked" class="text-xs-center">AANMELDEN</v-btn>

      </div>

    </div>
</div>


  </v-app>
</template>

<script>
import datareq from './datareq.js'
import grid from './grid.vue'
import materieel from './materieel.vue'
import werven from './werven.vue'
import handleidingen from './handleidingen.vue'
  export default {
    components: {
      datareq,
      materieel,
      werven,
      handleidingen,
      grid
    },
    data () {
      return {
        materieelSelected: false,
        wervenSelected: false,
        handleidingenSelected: false,
        accountSelected: true,
        validlogin: false,
        user: [],
        e1: true,
        e2: true,
        gebruikersnaam: '',
        wachtwoord: '',
        errormsg: '',
        showError: false,
        user_admin: false,

        UsersData: [],
        UsersColumns: [
          {key: 'username', value: 'gebruikersnaam', classes: 'bold'}
        ],
        UserGeselecteerd: false,
        UserUsername: '',
        UserVoornaam: '',
        UserNaam: '',
        UserID: -1,
        UserWW: ''
      }
    },
    created: function () {
      datareq.getData('UserLoginCheck', {}, this.jUserLoginCheck)
      this.$bus.$on('laadMachineDetailGlobal', this.laadDetailGlobal)
    },
    methods: {
      laadDetailGlobal: function () {
        this.deselectAll()
        this.materieelSelected = true
      },
      jUserLoginCheck: function (data) {
        if (data.status === 'NOLOGIN' || data.status === 'NOK') {
          this.loggedOut()
          return
        }
        this.user = data.data[0]
        this.loggedIn()
        this.materieelClicked()
        // this.$dispatch('PositionGlobal')
      },
      loggedIn: function () {
        this.validlogin = true
        this.showError = false
        this.e1 = true
        this.clearAll()
        this.user_admin = (this.user.admin === 1)
        if (this.user_admin === true) {
          datareq.getData('GetAlleUsers', {}, this.jsonUsersReceived)
        }
        //this.$broadcast('loadAccountPage', this.user)
        //this.$broadcast('ingelogd', this.user.username, this.user.type, this.user.compid)
        //this.$dispatch('PositionGlobal')
      },
      clearAll: function () {
        this.UsersData = []
        this.UserGeselecteerd = false
        this.UserUsername = ''
        this.UserVoornaam = ''
        this.UserNaam = ''
        this.UserID = -1
        this.UserWW = ''
      },
      jsonUsersReceived: function (data) {
        var status = data.status
        if (status === 'OK') {
          this.UsersData = data.data
        } else {
          this.$dispatch('logoutGlobal')
        }
      },
      loggedOut: function () {
        this.user = null
        this.validlogin = false
        this.user_admin = false
        this.accountClicked()
        // this.$broadcast('uitgelogd')
      },
      logout: function () {
        datareq.getData('UserLogout', {}, this.loggedOut)
      },
      deselectAll: function () {
        this.materieelSelected = false
        this.wervenSelected = false
        this.handleidingenSelected = false
        this.accountSelected = false
      },
      materieelClicked: function (event) {
        this.deselectAll()
        this.materieelSelected = true
        this.$bus.$emit('laadMaterieel')
      },
      wervenClicked: function (event) {
        this.deselectAll()
        this.wervenSelected = true
        this.$bus.$emit('laadWerven')
      },
      handleidingenClicked: function (event) {
        this.deselectAll()
        this.handleidingenSelected = true
        this.$bus.$emit('laadHandleidingen')
      },
      accountClicked: function (event) {
        this.deselectAll()
        this.accountSelected = true

        //datareq.getData('UserLogin', {username: 'vlb', password: 'vlb'}, this.jsonReceived)
      },

      kp: function (ev) {
        if (ev.key === 'Enter') {
          this.inloggenClicked()
        }
      },
      uitloggenClicked: function (event) {
        this.logout()
      },
      inloggenClicked: function (event) {
        if (this.gebruikersnaam === '') {
          this.warningmsg = 'Vul een gebruikersnaam in.'
          this.showWarning = true
          return
        }
        if (this.wachtwoord === '') {
          this.warningmsg = 'Vul een wachtwoord in.'
          this.showWarning = true
          return
        }
        datareq.getData('UserLogin', {username: this.gebruikersnaam, password: this.wachtwoord}, this.jsonReceived)
      },
      jsonReceived: function (data) {
      var status = data.status
      if (status === 'OK') {
        //this.$dispatch('loginGlobal', data.data[0])
        //this.resetFields()
        this.validlogin = true
        this.user = data.data[0]
        this.loggedIn()
      } else {
        this.errormsg = 'Gebruikersnaam of wachtwoord ongeldig.'
        this.showError = true
      }
    },
    jsonUpdated: function () {
      this.clearAll()
      if (this.user_admin === true) {
        datareq.getData('GetAlleUsers', {}, this.jsonUsersReceived)
      }
    },
    GridRowClicked: function (user) {
      this.UserGeselecteerd = true
      this.UserUsername = user.username
      this.UserVoornaam = user.voornaam
      this.UserNaam = user.naam
      this.UserID = user.id
      this.UserWW = ''
    },
    UserOpslaanClicked: function () {
      datareq.getData('UserGegevensWijzigen', {id: this.UserID, usern: this.UserUsername, naam: this.UserNaam, voornaam: this.UserVoornaam}, this.jsonUpdated)
    },
    UserVerwijderenClicked: function () {
      datareq.getData('UserVerwijderen', {id: this.UserID}, this.jsonUpdated)
    },
    UserWWWijzigen: function () {
      datareq.getData('UserWachtwoordWijzigen', {id: this.UserID, pwd: this.UserWW }, this.jsonUpdated)
    }
    }
  }
</script>

<style lang="stylus">
  @import './stylus/main'

.oneselected {
  background-color: red
}




</style>



// WEBPACK FOOTER //
// App.vue?ef755bae